import { useTranslation } from 'react-i18next';
import React, { useCallback, useMemo } from 'react';
import cx from 'clsx';
import styles from './index.module.scss';
import { IconRcSelectMore } from '@/assets/stream';
import { Dropdown } from '@/components';
import { usePrimePostIssues } from './hooks';

const MaxLength = 7;

export const IssueSelect = ({
  value,
  onChange,
}: {
  value?: string;
  onChange: (value: string) => void;
}) => {
  const { t } = useTranslation();

  const { data } = usePrimePostIssues({ enabled: true });

  const options = useMemo(
    () =>
      data?.map((i, index) => ({
        ...i,
        label:
          i.status === 'ongoing'
            ? t('IssueSelect.progress')
            : t('IssueSelect.issue', { name: data.length - index }),
      })),
    [data, t],
  );
  const displayOptions = options?.slice(0, MaxLength);
  const moreOptions = useMemo(
    () =>
      options?.slice(MaxLength)?.map(i => ({
        ...i,
        label: <span className={cx(styles.selectMoreItem)}>{i?.label}</span>,
        onClick: () => {
          onChange(String(i.id));
        },
      })),
    [onChange, options],
  );

  const currentSelectedIdx = useMemo(() => {
    return moreOptions?.findIndex(i => String(i.id) === value);
  }, [moreOptions, value]);

  const showMore = useMemo(() => options && options?.length > MaxLength, [options]);

  const handleSelect = useCallback(
    val => {
      onChange(val);
    },
    [onChange],
  );

  return (
    <div className={styles.container}>
      {displayOptions?.map(({ label, id }) => (
        <div
          className={cx(styles.item, String(id) === value && styles.selected)}
          onClick={() => handleSelect(String(id))}>
          {label}
        </div>
      ))}
      {showMore && (
        <Dropdown
          data={moreOptions}
          align={{ offset: [80, -24] }}
          currentSelectedIdx={currentSelectedIdx}
          dropdownListClassName={styles.dropdownList}>
          <IconRcSelectMore className={styles.selectMore} />
        </Dropdown>
      )}
    </div>
  );
};
